module.exports = __webpack_public_path__ + "static/media/Alert-Regions-Footmap-Right.4e5c0a19.png";